export default {
    home: "Rewarding platform",
    coupon_list: "Coupons | Rewarding platform",
    free_point_list: "Free points | Rewarding platform",
    history_list: "Histories | Rewarding platform",
    benefit_list: "Benefits | Rewarding platform",

    reward_detail: "Reward | {{name}}",
    benefit_detail: "Benefit | {{name}}",
    coupon_detail: "Coupon | {{name}}",
    free_point_detail: "Free point | {{name}}",

    membership_tier: "Membership tier | Rewarding platform",
    membership_detail: "Membership detail | Rewarding platform",
    user_setting: "{{name}} | Rewarding platform",
    user: "User setting",

    uploadreceipt_page: "Upload Receipt | Rewarding platform",
    badges_page: "Badges | Rewarding platform",
    badgesdetail_page: "Badges Detail | Rewarding platform",
    communityeventdetail_page: "Community Event Detail | Rewarding platform",
    communityevent_page: "Community Event | Rewarding platform",
    historyredeem_page: "History Redeem Detail | Rewarding platform",
    home_page: "Rewarding platform",
    luckydraw_page: "Lucky Draw | Rewarding platform",
    profile_page: "Profile | Rewarding platform",
    socialmedia_page: "Social Media | Rewarding platform",
    stateleaderboard_page: "MyState Leaderboard| Rewarding platform",
    mystate: "MyState | Rewarding platform",
    card_page: "Gift Cards | Rewarding platform",
    personal_page: "Personal | Rewarding platform",
    membercard_page: "Member Card | Rewarding platform",
    cardmember_page: "Card Member | Rewarding platform",
    survey_page: "Survey | Rewarding platform",
    membertype_page: "Member Type | Rewarding platform",
    eventactivity_page: "Event Activity | Rewarding platform",
    campaign_page: "Campaign | Rewarding platform",
    dailycheckin_page: "Daily CheckIn | Rewarding platform",
    purchases_page: "Purchases | Rewarding platform",
};
